import { useLang } from '@/app/utils/useLang';
import styles from './kr.module.scss';
import { Swiper, SwiperSlide } from 'swiper/react';
import { Pagination } from 'swiper';
import { getKrList } from './getKrList';
import EFPicture from '@elem/ui/ef-picture';
import { useState } from 'react';

const Battery = ({ power }: any) => (
    <svg className="phone-battery" xmlns="http://www.w3.org/2000/svg" width="69" height="34" viewBox="0 0 69 34" fill="none">
        <path d="M68.5 16.5C68.5 18.7021 66.7895 20.56 64.7815 21.4144V11.3262C66.7895 12.1806 68.5 14.2979 68.5 16.5Z" fill="black" />
        <rect
            x="4"
            y="4"
            width={(54 * power) / 100}
            height="26"
            rx="5"
            fill="#1CBC24"
            style={{
                transition: 'width 0.5s ease-in-out',
                WebkitTransition: 'width 0.5s ease-in-out',
            }}
        />
        <rect x="1" y="1" width="61" height="32" rx="5" stroke="black" stroke-width="2" />
    </svg>
);

const KrO2: React.FC = () => {
    const { t } = useLang('rapid.O2');

    const list = getKrList();
    const [swiperA, setSwiperA] = useState<any>(null); // 用于点击tab时执行轮播切换

    const [activeIndex, setActiveIndex] = useState(0);

    function handleClickTab(index: number) {
        setActiveIndex(index);
        swiperA.slideToLoop(index);
    }

    const handleSlideChange = (swiper: any) => {
        const index = swiper.realIndex; //下标
        setActiveIndex(index);
    };

    return (
        <div className={styles.KrO2}>
            <div className="title">{t('title')}</div>
            <Swiper
                slidesPerView={1}
                pagination={{
                    clickable: true,
                }}
                modules={[Pagination]}
                onSlideChange={handleSlideChange}
                onSwiper={(swiperIns: any) => setSwiperA(swiperIns)}
            >
                {list.map((item) => {
                    return (
                        <SwiperSlide className="wrapper-item" key={item.label}>
                            <div className="left">
                                <div className="desc">{item.desc}</div>

                                <div className="phone-list">
                                    {item.data.map((_item) => (
                                        <div className="phone-info" key={_item.name}>
                                            <div className="phone-top">
                                                <img className="phone-img" src={_item.img} alt="" />
                                                <div className="flex flex-col justify-between">
                                                    <div>
                                                        <span className="phone-power">{_item.power}</span>
                                                        {_item.type !== 'text' && <span className="phone-percent">%</span>}
                                                    </div>
                                                    {_item.type === 'text' ? <span className="item-text">회</span> : <Battery power={_item.power} />}
                                                </div>
                                            </div>
                                            <span className="phone-name">{_item.name}</span>
                                        </div>
                                    ))}
                                    <div className="right-pc">
                                        <EFPicture
                                            src="https://websiteoss.ecoflow.com/upload/image/1747980864080/%E9%93%B6%E8%89%B25000mah%20(1).png"
                                            srcMobile="https://websiteoss.ecoflow.com/upload/image/1747983189760/%E9%93%B6%E8%89%B25000mah%20(2)%20(1).png"
                                        />
                                    </div>
                                </div>
                            </div>
                            <div className="right-h5">
                                <EFPicture
                                    src="https://websiteoss.ecoflow.com/upload/image/1747980864080/%E9%93%B6%E8%89%B25000mah%20(1).png"
                                    srcMobile="https://websiteoss.ecoflow.com/upload/image/1747983189760/%E9%93%B6%E8%89%B25000mah%20(2)%20(1).png"
                                />
                            </div>
                        </SwiperSlide>
                    );
                })}
            </Swiper>

            <div className="wrapper-tabs">
                <div className="tabs">
                    {list.map((item, index) => {
                        return (
                            <div className={'tab-item ' + (activeIndex === index ? 'active' : 0)} key={item.label} onClick={() => handleClickTab(index)}>
                                {item.label}
                            </div>
                        );
                    })}
                </div>
            </div>
        </div>
    );
};

export default KrO2;
